import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Nov 25 2019
 *
 * @///<reference path="packages/promo-optimization-api/src/model/PromoOptimizationLearning.ts"/>
 *
 * @author Adam Drda
 * @author Vojtěch Smolař
 */
import { DomainObject } from '@logio/common-be-fe';
import { List } from 'immutable';
import { PromoOptimizationLearningState } from '../enums/PromoOptimizationLearningState';
/**
 *
 * @param id unique internal identifier
 * @param bulkWriteRequestId bulkWriteRequestId returned from PromoOptimizationAPI
 * @param calculationId calculationId returned from PromoOptimizationAPI
 * @param state state of learning
 * @param createdAt date of learning creation
 * @param exportStartedAt date of export started
 * @param uploadStartedAt date of upload started
 * @param calculationStartedAt date calculation started
 * @param updatedAt date of last learning
 * @param error description of last error if this record is in failed state
 */

export var PromoOptimizationLearning =
/*#__PURE__*/
function (_DomainObject) {
  _inherits(PromoOptimizationLearning, _DomainObject);

  function PromoOptimizationLearning(id, bulkWriteRequestId, calculationId, state, createdAt, exportStartedAt, exportFinishedAt, uploadStartedAt, uploadFinishedAt, calculationStartedAt, calculationFinishedAt, updatedAt, error) {
    var _this;

    _classCallCheck(this, PromoOptimizationLearning);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromoOptimizationLearning).call(this));
    _this.id = id;
    _this.bulkWriteRequestId = bulkWriteRequestId;
    _this.calculationId = calculationId;
    _this.state = state;
    _this.createdAt = createdAt;
    _this.exportStartedAt = exportStartedAt;
    _this.exportFinishedAt = exportFinishedAt;
    _this.uploadStartedAt = uploadStartedAt;
    _this.uploadFinishedAt = uploadFinishedAt;
    _this.calculationStartedAt = calculationStartedAt;
    _this.calculationFinishedAt = calculationFinishedAt;
    _this.updatedAt = updatedAt;
    _this.error = error;
    return _this;
  }

  return PromoOptimizationLearning;
}(DomainObject);
/**
 * States of the PromoOptimizationLearning that mean the learning has finished.
 */

PromoOptimizationLearning.ENDED_STATES = List.of(PromoOptimizationLearningState.Error, PromoOptimizationLearningState.Killed, PromoOptimizationLearningState.CalculationSuccess);